import { render, staticRenderFns } from "./PdfViewer1.vue?vue&type=template&id=bcc8a142&scoped=true"
import script from "./PdfViewer1.vue?vue&type=script&lang=js"
export * from "./PdfViewer1.vue?vue&type=script&lang=js"
import style0 from "./PdfViewer1.vue?vue&type=style&index=0&id=bcc8a142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc8a142",
  null
  
)

export default component.exports